import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { useYupFields } from 'hooks/forms/useYupFields'

export interface MerchantFormData {
  merchantName: string
  walletId: string
  webhookUrl: string
}

export type MerchantFormKeys = keyof MerchantFormData

export const useMerchantFormSchema = (t: TFunction<'translation', undefined>) => {
  const { getRequiredYupField, getYupField } = useYupFields()

  const merchantName = getRequiredYupField({
    label: t('merchantName'),
  }).max(40, t('merchantNameLengthError'))

  const walletId = getRequiredYupField({
    label: t('wallet'),
  })

  const webhookUrl = getYupField({
    label: t('webhookUrl'),
  }).test('webhook-url-validation', t('webhookUrlInvalidMsg'), value => {
    if (!value) return true

    const hasValidProtocol = value.startsWith('http://') || value.startsWith('https://')
    const hasNoSpaces = !value.includes(' ')

    return hasValidProtocol && hasNoSpaces
  })

  return yup.object({
    merchantName,
    walletId,
    webhookUrl,
  })
}
